import React, { Component } from 'react'
import axios from "axios";
import * as Yup from 'yup';
import { Formik, Form, Field, ErrorMessage }  from "formik";


//define Customer API URL call
// let baseurl = 'http://scsitev1apis-env.eba-hnxtukew.us-east-2.elasticbeanstalk.com'
// let baseurl = 'https://validation.stickchart.dev'
// let baseurl = 'http://192.168.1.159:8081'
let baseurl = process.env.GATSBY_API_TARGET
let regurl = baseurl + '/api/registeredusers/';
let refurl = baseurl + '/api/referredusers/';
let access_token = process.env.GATSBY_API_KEY

if (process.env.GATSBY_ACTIVE_ENV === 'development') {
  console.log("***LOG RESPONSE*** GATSBY_API_KEY: " + process.env.GATSBY_API_KEY)
  console.log("***LOG RESPONSE*** API_KEY: " + process.env.API_KEY)
  console.log("***LOG RESPONSE*** NODE_ENV: " + process.env.NODE_ENV)
  console.log("***LOG RESPONSE*** ACTIVE_ENV: " + process.env.GATSBY_ACTIVE_ENV)
}

//Set Initial Values for Form
const initialValues = {
    firstName: "",
    lastName: "",
    eMailPrimary: "",
};

const SignupSchema = Yup.object().shape({
    firstName: Yup.string()
        .min(2, 'Too Short!')
        .max(45, 'Too Long!')
        .required('First Name Is Required'),
    lastName: Yup.string()
        .min(2, 'Too Short!')
        .max(45, 'Too Long!')
        .required('Last Name Is Required'),
    eMailPrimary: Yup.string().email('Invalid email').required('Your Email Address Is Required'),
});


export default class RegistrationModal extends Component {
    state = {
        items: [],
        value: "",
        error: null
    };

    handleKeyDown = evt => {
        if (["Enter", "Tab", ","].includes(evt.key)) {
        evt.preventDefault();

        var value = this.state.value.trim();

        if (value && this.isValid(value)) {
            this.setState({
            items: [...this.state.items, this.state.value],
            value: ""
            });
        }
        }
    };

    handleChange = evt => {
        this.setState({
        value: evt.target.value,
        error: null
        });
    };

    handleDelete = item => {
        this.setState({
        items: this.state.items.filter(i => i !== item)
        });
    };

    handleKeyDown(e) {
        if (e.keyCode === 27) {
            closeModal()
        }
    };

    handleReset = evt => {
        this.setState({
            items: []
        })
    };

    handlePaste = evt => {
        evt.preventDefault();

        var paste = evt.clipboardData.getData("text");
        var emails = paste.match(/[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/g);

        if (emails) {
        var toBeAdded = emails.filter(email => !this.isInList(email));

        this.setState({
            items: [...this.state.items, ...toBeAdded]
        });
        }
    };

    isValid(email) {
        let error = null;

        if (this.isInList(email)) {
        error = `${email} has already been added.`;
        }

        if (!this.isEmail(email)) {
        error = `${email} is not a valid email address.`;
        }

        if (error) {
        this.setState({ error });

        return false;
        }

        return true;
    }

    isInList(email) {
        return this.state.items.includes(email);
    }

    isEmail(email) {
        return /[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/.test(email);
    }
    

    submitCloseModal = e => {
        this.props.closeModal && this.props.closeModal(e);
        this.props.confirmModal && this.props.confirmModal(e);
    };
    //Close Modal Function
    closeModal = e => {
        this.props.closeModal && this.props.closeModal(e);
    };

    render() {
        
        //For Modal Styling (make visible or not)
        const divStyle = { 
            display: this.props.displayModal ? 'block' : 'none'
        };

        // const { inputValue, eMailReferral } = this.state;

        return (
            // load the modal background first
            <div aria-hidden="true" className="modal" onClick={ this.closeModal } onKeyDown={ this.handleKeyDown } style={divStyle} >
                {/* load modal window itself */}
                <div aria-hidden="true" className="modal-content" onClick={ e => e.stopPropagation() } onKeyDown={ e => e.stopPropagation() }>
                    <div className="modal-flex">
                        {/* the close (x) button for the modal */}
                        <div class="px-4">
                            <span aria-hidden="true" className="close" onClick={ this.closeModal } onKeyDown={ this.handleKeyDown } >&times;</span>
                        </div>
                            {/* Modal Heading */}
                            <div class="px-2 md:px-10 w-full mx-auto text-center">
                                <h3>Help design your perfect communication tool</h3> {/* formatting specified in global.css - modal-flex h3 */}
                            </div>
                            {/* Initiate Form */}
                            <Formik
                                class="mb-4 md:flex md:flex-wrap md:justify-between"
                                initialValues={initialValues}
                                validationSchema={SignupSchema}
                                onSubmit={(fields, { setSubmitting }) => {
                                    setTimeout(() => {
                                        //Get the SessionID - used to commit data to API
                                        const sessionID = typeof window !== 'undefined' && window.localStorage.getItem('stickchart:_sc_id');;
                                        
                                        //Writing values to localStorage
                                        //Registration complete, will prevent pop-up in the future
                                        typeof window !== 'undefined' && window.localStorage.setItem('stickchart:_sc_registered', true);
                                        //Sets Usertype for the Registered User
                                        typeof window !== 'undefined' && window.localStorage.setItem('stickchart:_sc_registered_usertype', this.props.usertype);
                                        //Sets First Name for the Registered User
                                        typeof window !== 'undefined' && window.localStorage.setItem('stickchart:_sc_registered_fName', fields.firstName);
                                        //Sets Last Name for the Registered User
                                        typeof window !== 'undefined' && window.localStorage.setItem('stickchart:_sc_registered_lName', fields.lastName);
                                        //Sets Email for the Registered User
                                        typeof window !== 'undefined' && window.localStorage.setItem('stickchart:_sc_registered_email', fields.eMailPrimary);
                                        //Logs any referral email addresses
                                        typeof window !== 'undefined' && window.localStorage.setItem('stickchart:_sc_registered_referral_emails', this.state.items);

                                        // //API call to commit data to backend
                                        axios.post(regurl, {
                                            session_id: sessionID,
                                            email_address: fields.eMailPrimary,
                                            first_name: fields.firstName,
                                            last_name: fields.lastName,
                                            user_type: this.props.usertype,
                                        }, {
                                            headers: {
                                                // Pass api key in via auth header
                                                'Authorization': 'Api-Key ' + access_token
                                            }
                                        })
                                        .then((response) => {
                                            if (process.env.GATSBY_ACTIVE_ENV === 'development') {
                                                console.log("***LOG RESPONSE*** **Axios Response** " + JSON.stringify(response));
                                            }
                                            if(this.state.items.length > 0 ) {
                                                //Prepare update call to referred user API
                                                for (let i = 0; i < this.state.items.length; i++) {
                                                    // //API call to commit data to backend
                                                    axios.post(refurl, {
                                                        referring_id: sessionID,
                                                        email_address: this.state.items[i],
                                                    }, {
                                                        headers: {
                                                            // Pass api key in via auth header
                                                            'Authorization': 'Api-Key ' + access_token
                                                        }
                                                    })
                                                    .then((response) => {
                                                        // console.log("**Registration - Add ReferredUser via API success** " + response);
                                                        if (process.env.GATSBY_ACTIVE_ENV === 'development') {
                                                            console.log("***LOG RESPONSE*** **Axios Response** " + JSON.stringify(response));
                                                        }
                                                    }, (error) => {
                                                        // console.log("**Registration - Add ReferredUser via API ERROR** " + error)
                                                        if (process.env.GATSBY_ACTIVE_ENV === 'development') {
                                                            console.log("***LOG RESPONSE*** **Axios Error** " + JSON.stringify(error));
                                                        }
                                                    })
                                                }
                                            }
                                        }, (error) => {
                                            // console.log("**Registration - Add RegisteredUser via API ERROR** " + error)
                                            if (process.env.GATSBY_ACTIVE_ENV === 'development') {
                                                console.log("***LOG RESPONSE*** **Axios Error** " + JSON.stringify(error));
                                            }
                                        })

                                        

                                        this.submitCloseModal()

                                        setSubmitting(false);
                                    }, 400);
                                    
                                }}
                                render={({ errors, status, touched }) => (
                                    <Form>
                                        <div className="form-group">
                                            <div class="scmd:px-2 w-full mx-auto text-center">
                                                <p>
                                                    We’re looking for future users to work with as we build StickChart.<br/><br/>Give us your email below and we’ll provide updates and reach out with questions along the way.
                                                </p>
                                            </div>
                                            <div class="flex flex-col mb-4">
                                                <label class="capitalize font-semibold text-sm text-gray-600" htmlFor="firstName">First Name</label>
                                                <Field name="firstName" type="text" class={'modal-form-control' + (errors.firstName && touched.firstName ? ' modal-form-control-error' : '')} />
                                                <ErrorMessage name="firstName" component="div" class="text-xs text-red-500 mt-1" />
                                            </div>
                                            <div className="flex flex-col mb-4">
                                                <label class="capitalize font-semibold text-sm text-gray-600" htmlFor="lastName">Last Name</label>
                                                {/* <Field name="lastName" type="text" className={'form-control' + (errors.lastName && touched.lastName ? ' is-invalid' : '')} /> */}
                                                <Field name="lastName" type="text" class={'modal-form-control' + (errors.lastName && touched.lastName ? ' modal-form-control-error' : '')} />
                                                {/* <ErrorMessage name="lastName" component="div" className="invalid-feedback" /> */}
                                                <ErrorMessage name="lastName" component="div" class="text-xs text-red-500 mt-1" />
                                            </div>
                                            <div className="flex flex-col mb-4">
                                                <label class="capitalize font-semibold text-sm text-gray-600" htmlFor="eMailPrimary">Email</label>
                                                <Field name="eMailPrimary" type="text" class={'modal-form-control' + (errors.eMailPrimary && touched.eMailPrimary ? ' modal-form-control-error' : '')} />
                                                <ErrorMessage name="eMailPrimary" component="div" class="text-xs text-red-500 mt-1" />
                                            </div>
                                            <div class="hidden scmd:block scmd:px-2 w-full mx-auto text-center">
                                                <p>
                                                    Do you have a colleague or customer who we should reach out to for input?  Please share their emails.
                                                </p>
                                            </div>
                                            <div className="hidden scmd:block flex flex-col mb-4">
                                                <label class="capitalize font-semibold text-sm text-gray-600" htmlFor="eMailReferral">Refer Your Colleague (Email)</label>
                                                <div className="flex flex-wrap md:w-full">
                                                    {this.state.items.map(item => (
                                                        <div className="tag-item" key={item}>
                                                            {item}
                                                            <button
                                                            type="button"
                                                            className="button"
                                                            onClick={() => this.handleDelete(item)}
                                                            >
                                                            &times;
                                                            </button>
                                                        </div>
                                                        ))}
                                                </div>
                                                <div className="flex flex-col mb-4">
                                                    <input
                                                        className={'modal-form-control ' + (this.state.error && " has-error modal-form-control-error")}
                                                        value={this.state.value}
                                                        placeholder="Type/paste email addresses & press `Enter`..."
                                                        onKeyDown={this.handleKeyDown}
                                                        onChange={this.handleChange}
                                                        onPaste={this.handlePaste}
                                                        type="email"
                                                    />
                                                    
                                                    <label class="text-xs text-gray-600" htmlFor="eMailReferral">Enter as many email addresses as you would like, just press Enter (Go) after each one</label>
                                                    {this.state.error && <p class="text-xs text-red-500 mt-1">{this.state.error}</p>}
                                                </div>
                                            </div>
                                        </div> 
                                        {/* Submit Button */}
                                        <button id="btn-regupdatemodalsubmit-id" type="submit" class="submit-btn">Sign Up</button>
                                        {/* <div className="flex flex-col md:w-full">
                                            <button onClick={this.handleReset} type="reset" class="block py-4 w-full text-center no-underline text-sm text-grey-dark hover:text-grey-darker">Reset Form</button>
                                        </div> */}
                                    </Form>
                                )}
                            />
                </div> 
            </div>
        </div>
        )
    }
}
